import {RouteRecordRaw} from "vue-router"
import ContactPersonContainerView from "@/views/ContactPerson/ContactPersonContainerView.vue"

// const ContactPersonDashboardView = () => import('@/views/ContactPerson/DashboardView.vue')
const ContactPersonManagedStudentsView = () => import('@/views/ContactPerson/ManagedStudentListView.vue')

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/contact_person',
        component: ContactPersonContainerView,
        children: [
            // {
            //     path: 'dashboard',
            //     name: 'contact_person_dashboard',
            //     component: ContactPersonDashboardView,
            // },
            {
                path: 'managed_students',
                name: 'contact_person_managed_students',
                component: ContactPersonManagedStudentsView,
            }
        ]
    },
]
